import { render, staticRenderFns } from "./ToolbarDeVenda.vue?vue&type=template&id=7252a695&scoped=true&"
import script from "./ToolbarDeVenda.vue?vue&type=script&lang=ts&"
export * from "./ToolbarDeVenda.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarDeVenda.vue?vue&type=style&index=0&id=7252a695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252a695",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAppBar,VBtn,VIcon,VSlideGroup,VSlideItem,VSpacer,VToolbarTitle,VTooltip})
